import axios from 'axios';
import { getStoredToken, isTokenValid, removeToken } from '../utils/Auth';
import { getSelectedLocale } from '../utils/Localization';
import { getCookie } from '../utils/Cookie';
import { AFFILIATE_COOKIE_KEYS } from '../constants/Affiliate';

export const apiPrefix = '/api';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((request) => {
  const token = getStoredToken();
  if (token) {
    if (isTokenValid()) {
      request.headers.set('Authorization', `Bearer ${token}`);
    } else {
      removeToken();
    }
  }

  request.headers.set('Accept-Language', getSelectedLocale());

  const affiliateCode = getCookie(AFFILIATE_COOKIE_KEYS.AFFILIATE_CODE);
  const visitorId = getCookie(AFFILIATE_COOKIE_KEYS.AFFILIATE_VISITOR_ID);

  if (affiliateCode) {
    request.headers.set('X-NNET-AFFILIATE-CODE', affiliateCode);
  }

  if (visitorId) {
    request.headers.set('X-NNET-VISITOR-ID', visitorId);
  }

  return request;
});

api.interceptors.response.use(
  (response) => response,
  async (err) => {
    if (err?.response?.data?.error) {
      throw new Error(err.response.data.error);
    }

    throw new Error('Unknown API error.');
  },
);

export default api;
